import FileUploadeAbstract from './FileUploadeAbstract';

export default class FileUploadeFront extends FileUploadeAbstract {
    constructor(file) {
        super(file.name);
        this.file = file;
    }

    async download() {
        const objectURL = window.URL.createObjectURL(this.file);

        const tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = objectURL;
        tempLink.setAttribute('download', this.filename);

        // Safari thinks _blank anchor are pop ups. We only want to set _blank
        // target if the browser does not support the HTML5 download attribute.
        // This allows you to download files in desktop safari if pop up blocking
        // is enabled.
        if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank');
        }

        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(objectURL);
    }

    async getFileToSend() {
        const transform = new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(this.file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

        await Promise.all([transform]);
        let base64 = null;
        await transform.then((contenu) => {
            base64 = contenu;
        });

        return {
            filename: this.filename,
            contenu: base64,
        };
    }
}
